import { FileText, Table } from 'lucide-react';

import { Button } from '~shared/shadcn/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~shared/shadcn/ui/dialog';

interface AttendanceExportFormatDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onFormatSelect: (format: 'pdf' | 'csv') => void;
  showBalance: boolean;
}

export const AttendanceExportFormatDialog = ({
  open,
  onOpenChange,
  onFormatSelect,
  showBalance,
}: AttendanceExportFormatDialogProps) => {
  const handleFormatSelect = (format: 'pdf' | 'csv') => {
    onFormatSelect(format);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>Choose Export Format</DialogTitle>
          <DialogDescription>
            Select the format for your attendance sheet export
            {showBalance ? ' with balances' : ' without balances'}.
          </DialogDescription>
        </DialogHeader>
        <div className='flex flex-col gap-3 py-4'>
          <Button
            variant='outline'
            className='flex h-auto items-center justify-start gap-3 p-4'
            onClick={() => {
              handleFormatSelect('pdf');
            }}
          >
            <FileText className='size-5 text-red-500' />
            <div className='text-left'>
              <div className='font-medium'>PDF Format</div>
            </div>
          </Button>
          <Button
            variant='outline'
            className='flex h-auto items-center justify-start gap-3 p-4'
            onClick={() => {
              handleFormatSelect('csv');
            }}
          >
            <Table className='size-5 text-green-500' />
            <div className='text-left'>
              <div className='font-medium'>CSV Format</div>
            </div>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
